import React from 'react';
import { useBookingContext } from '../BookingContext';
import { formatUsTime, calculateRequiredCredits, getSelectedActivityDurationHours, formatLocation, formatActivityDuration } from '../../../utils/bookingUtils';
import DriversSection from './DriversSection';

const ReviewSection: React.FC = () => {
  const { booking } = useBookingContext();
  const durationHours = getSelectedActivityDurationHours(booking.activities, booking.activityId);
  const requiredCredits = calculateRequiredCredits(
    booking.activities,
    booking.activityId,
    booking.fullMotionSimulators,
    booking.esportsSimulators
  );

  return (
    <div className="d-flex flex-column gap-3">
      <div>
        <h3 className="mb-1 heading text-center">Review Booking</h3>
      </div>

      <div className="card">
        <div className="card-body py-2 px-3 text-white">
          <div className="row g-2">
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Location</div>
              <div>{booking.location ? formatLocation(booking.location) : '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Duration</div>
              <div>{durationHours ? formatActivityDuration(durationHours) : '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Cost</div>
              <div>{requiredCredits ? `${requiredCredits} credits` : '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Date</div>
              <div>{booking.date || '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Start time</div>
              <div>{booking.startTime ? formatUsTime(booking.startTime) : '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">End time</div>
              <div>{booking.endTime ? formatUsTime(booking.endTime) : '—'}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Full Motion</div>
              <div>{booking.fullMotionSimulators}</div>
            </div>
            <div className="col-6 col-md-4">
              <div className="settings-field-label">Esports</div>
              <div>{booking.esportsSimulators}</div>
            </div>
          </div>
        </div>
      </div>

      <DriversSection />
    </div>
  );
};

export default ReviewSection;
